SlideView = require("views/slide")

class ListView extends SlideView
  template: require("./template")

  events:
    "iostap .btn-done": "submit"

module.exports = ListView
